import * as React from "react";
import { SVGProps } from "react";
const SvgTl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 36 18"
    {...props}
  >
    <path fill="#da291c" d="M0 0h36v18H0z" />
    <path fill="#ffc72c" d="M18 9 0 18V0z" />
    <path d="M12 9 0 18V0z" />
    <path
      fill="#fff"
      d="m2.782 6.259 3.815 4.243-5.58-1.19L6.23 6.994l-2.857 4.94z"
    />
  </svg>
);
export default SvgTl;
